// extracted by mini-css-extract-plugin
export default {"theme_shimmer":"#242939","theme_shimmer_bg":"#1a1d27","theme_shimmer_leads":"#1e232d"};